import { render, staticRenderFns } from "./order-row.vue?vue&type=template&id=35907c06&"
import script from "./order-row.vue?vue&type=script&lang=js&"
export * from "./order-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports